export default __webpack_public_path__ + "static/media/fasting_16_8@3x.2438d35d.jpg";